<template>
    <div>
        <h3>Saved</h3>
        <p>The details for <b>{{name}}</b> have been saved</p>
        <p class="">You can continue to work on this whenever you like</p>
        <md-button class="md-success md-raised" @click="$emit('done')">Ok, I'll continue later</md-button>
        <h3 style="margin-top:10rem;">Ready to Generate?</h3>
        <p class="">If you are now complete and ready to <b>generate the website ?</b></p>
        <p>Please click below for the confirmation details</p>
        <md-button class="md-success md-raised" @click="$emit('showGeneratePage')">I'm ready</md-button>
    </div>
</template>

<script>
    export default {
        name: 'BuildingSaved',
        props: {
            name:null,
        }
    }
</script>

<style lang="scss">
 
</style>
